<i18n>
{
  "en": {
    "title": "Schneider Electric Foundation Highlights 2017-2018",
    "description": "The Schneider Electric Foundation uses innovation and community engagement to help people develop skills in energy and entrepreneurship, support families who suffer from fuel poverty, and build a sustainable world for everyone. See the foundation’s 2017-2018 highlights and learn more.",
    "outreach": {
      "section": "Outreach and Initiatives",
      "title": "Schneider Electric Foundation",
      "foundation": {
        "txtMedia1": {
          "p1": "In 2018, we celebrate the 20th anniversary of the Schneider Electric Foundation, which operates under the aegis of Fondation de France, and uses innovation and community engagement to reduce the energy gap and increase sustainability awareness."
        },
        "table1": {
          "row1": {
            "cell1": {
              "title": "Investing in education"
            },
            "cell2": {
              "p1": "The foundation focuses on emerging countries, helping people develop skills in energy and entrepreneurship. At the end of 2017, a total of 148,145 people had benefited from training programs since 2009."
            }
          },
          "row2": {
            "cell1": {
              "title": "Reducing the energy gap"
            },
            "cell2": {
              "p1": "In more mature economies such as in Europe and North America, the foundation supports families who suffer from fuel poverty — those who cannot pay their energy bills and/or benefit from the right level of comfort they deserve."
            }
          },
          "row3": {
            "cell1": {
              "title": "Increasing sustainability awareness"
            },
            "cell2": {
              "p1": "The foundation promotes innovative solutions that mix social entrepreneurship, art, and creativity. This ensures that &mdash; while the foundation works to bring energy to those in need &mdash; it also works to build a sustainable world for everyone."
            }
          }
        },
        "txt1": {
          "title": "Natural disaster relief",
          "p1": "In 2017, many people across the world were affected by natural disasters and we were compelled to help as much as possible. This included the deployment of teams and technology to support the people impacted by the earthquake in Mexico and by hurricanes Harvey, Maria, and Irma in the U.S., Caribbean, and Costa Rica.",
          "p2": "Our total contribution included $1 million, plus 150 emergency tents, and 4,000 solar lamps distributed in collaboration with La Cruz Roja Mexicana, SOS Attitude, and Electriciens sans frontières."
        },
        "txt2": {
          "title": "A symbol for solutions",
          "p1": "Launched in 2015 by Art of Change 21, Maskbook is an international art project. Through exhibitions, workshops, and more, Maskbook raises awareness on the increasingly high stakes of air pollution and climate change. Through Maskbook, the dust mask, a symbol for pollution, is transformed into a symbol for solutions. Maskbook has thousands of participants from more than 40 countries.",
          "p2": "The Schneider Electric Foundation is Maskbook’s main partner. Since 2016, the U.N. Environment and the Climate and Clean Air Coalition have been institutional partners as well."
        },
        "vid1": {
          "title": "Art in Action",
          "description": "Maskbook fights climate change through creativity."
        },
        "barometer1": {
          "title": "2015 – 2017 Planet <span class='t-nowrap'>& Society</span> barometer achievements",
          "cta": "See the full results",
          "card1": {
            "title": "Development",
            "stat": "148,145",
            "body": "underprivileged people trained in energy management"
          },
          "card2": {
            "title": "Development",
            "stat": "1,347",
            "body": "missions within Schneider Electric Teachers NGO"
          }
        },
        "txt3": {
          "h2": "2017 Schneider Electric Foundation highlights",
          "title": "Investing €2 million for training underprivileged youths",
          "p1": "True innovation extends opportunity to those less fortunate, and so we endeavor to use innovation as a way to lift up and empower the next generation, especially the underprivileged. To that end, the Schneider Foundation signed a partnership with the General Council of the Salesian Congregation, investing €2 million. This initiative will first fund five renewable energy and sustainable development projects selected from proposals made by numerous Salesian technical and professional schools worldwide.",
          "p2": "The goal is to help provide young, unprivileged people with opportunities while promoting a sustainable way of life:",
          "li1": "In Goma in the Democratic Republic of the Congo, the ITIG Professional Training Center's projects will provide theoretical and practical training to students from poor families.",
          "li2": "In Pinguli, Kudal in India, electrical lab tools will be upgraded at the local vocational center.",
          "li3": "In Haiti, training will be set up for teachers, new laboratory and student equipment will be purchased, and a new electricity generation system will be created.",
          "li4": "In Maputo, Mozambique, the student and teacher training program will be updated in the field of energy.",
          "li5": "In Sicily, Innovation 4.0 classes will be launched in electricity, electronics, and renewable energy."
        },
        "txt4": {
          "title": "Schneider Electric Teachers",
          "p1": "With the Schneider Electric Teachers NGO, employees can volunteer to train others. They become the link between the company, the Schneider Electric Foundation, and supported organizations in more than 70 countries and 1,347 missions carried out over the past three years."
        },
        "txtMedia2": {
          "title": "VolunteerIn",
          "p1": "Our multilingual platform VolunteerIn allows employees to apply for volunteer work with the foundation’s partners. This includes missions organized by Schneider Electric Teachers. The foundation communities (team, delegates and NGO partners) manage the platform, focusing on vocational energy training, supporting energy-poor families, and raising awareness of sustainable development and entrepreneurship."
        },
        "quoteVol": {
          "p": "We share the value of a new world for electricity where people are empowered … the projects we are developing with Schneider and Ashoka today go in the same direction.",
          "title": "Head of Sustainability,",
          "company": "Enel Distribution"
        },
        "quoteTeachers": {
          "p": "I just hope to have given as much as I received during this mission! We are a special company because of our people and initiatives like Schneider Electric Teachers. I am very proud to be part of it.",
          "title": "OEM Sales,",
          "company": "Schneider Electric"
        },
        "snapshot1": {
          "title": "Schneider Electric Foundation by the numbers",
          "cell1": {
            "title": "€13.4 million",
            "p1": "financial and in-kind contributions by Schneider Electric employees and entities"
          },
          "cell2": {
            "title": "€4 million",
            "p1": "intervention budget"
          },
          "cell3": {
            "title": "130",
            "units": "delegates",
            "p1": "in 80 countries"
          },
          "cell4": {
            "title": "1,347",
            "units": "Schneider Electric Teachers",
            "p1": "missions carried out over the past 5 years"
          },
          "cell5": {
            "title": "35,000",
            "p1": "collaborators"
          },
          "cell6": {
            "title": "35,000",
            "units": "contributors",
            "p1": "1,900 volunteers"
          },
          "cell7": {
            "title": "840",
            "units": "partners",
            "p1": "since the creation of the foundation"
          }
        },
        "txt5": {
          "title": "Social innovation to tackle fuel poverty",
          "p1": "In June 2017, the Schneider Electric Foundation — under the aegis of Foundation de France — and Ashoka, launched a new call for projects in the Social Innovation to Tackle Fuel Poverty program. In partnership with Enel, the goal was to find the 15 most innovative organizations that offer creative solutions to tackle fuel poverty and promote energy sustainability in Europe. The winners were announced during the 23rd session of the Conference of the Parties (COP23) in November 2017."
        },
        "vid2": {
          "title": "Social Entrepreneurship",
          "description": "Winning innovations were announced at COP23."
        },
        "txtMedia3": {
          "title": "Creative Klima at COP23",
          "p1": "Another initiative by Art of Change 21, Creative Klima offers exhibitions, conferences, workshops, debates, award ceremonies, musical programming, and numerous festivities &mdash; they provided inspiration for action in the fight against climate change at COP23.",
          "p2": "Partners included the Schneider Electric Foundation, the Association Art of Change 21, the international NGO Ashoka, the Institut français Bonn, Atelier 21 with its initiatives Paléo-Energétique and Solar Sound System, and the International Weather and Climate Forum."
        },
        "references": {
          "referenceA": "<sup>1</sup> <a class='t-grey' href='https://www.iea.org/publications/freepublications/publication/weo-2017-special-report-energy-access-outlook.html' target='_blank'>International Energy Agency, Energy Access Outlook 2017</a>"
        }
      }
    }
  },
  "fr": {
    "title": "Schneider Electric Foundation Highlights 2017-2018",
    "description": "The Schneider Electric Foundation uses innovation and community engagement to help people develop skills in energy and entrepreneurship, support families who suffer from fuel poverty, and build a sustainable world for everyone. See the foundation’s 2017-2018 highlights and learn more.",
    "outreach": {
      "section": "Initiatives et Communautés",
      "title": "Fondation Schneider Electric",
      "foundation": {
        "txtMedia1": {
          "p1": "En 2018, nous célébrons le 20e anniversaire de la Fondation Schneider Electric, sous l'égide de la Fondation de France. La Fondation Schneider Electric mise sur l’innovation et l’engagement des communautés pour réduire la fracture énergétique et accroître la sensibilisation au développement durable. "
        },
        "table1": {
          "row1": {
            "cell1": {
              "title": "Réduire la fracture énergétique"
            },
            "cell2": {
              "p1": "La Fondation concentre ses actions sur les pays émergents, en aidant les populations à développer des compétences dans le domaine de l’énergie et de l’entrepreneuriat. Fin 2017, 148 145 personnes avaient bénéficié de programmes de formation depuis 2009."
            }
          },
          "row2": {
            "cell1": {
              "title": "Réduire la fracture énergétique"
            },
            "cell2": {
              "p1": "Dans des économies plus matures, en Europe et en Amérique du Nord, la Fondation apporte son soutien aux familles touchées par la précarité énergétique, c’est-à-dire celles qui ne peuvent pas payer leurs factures d'énergie ou bénéficier du degré de confort auquel elles ont droit."
            }
          },
          "row3": {
            "cell1": {
              "title": "Renforcer la sensibilisation au développement durable"
            },
            "cell2": {
              "p1": "La Fondation promeut les solutions  innovantes. En œuvrant à faire accéder les personnes qui en ont le plus besoin à l’énergie, elle s’engage également à bâtir un monde durable pour tous."
            }
          }
        },
        "txt1": {
          "title": "Interventions en cas de catastrophes naturelles",
          "p1": "En 2017, de nombreuse personnes ont été touchées par les catastrophes naturelles et nous nous sommes efforcés de les aider de notre mieux. Nous avons déployé des équipes et du matériel pour soutenir les populations touchées par le tremblement de terre au Mexique et par les ouragans Harvey, Maria et Irma aux États-Unis, dans les Caraïbes et au Costa Rica.",
          "p2": "Notre contribution totale comprenait 1 million de dollars, 150 tentes d’urgence et 4 000 lampes solaires distribuées en collaboration avec la Croix-Rouge mexicaine, SOS Attitude, et Électriciens sans frontières."
        },
        "txt2": {
          "title": "Symbole de solutions",
          "p1": "Lancé en 2015 par Art of Change 21, Maskbook est un projet artistique international. À travers des expositions et des ateliers, entre autres, Maskbook sensibilise aux défis dramatiques que représentent la pollution atmosphérique et le changement climatique. Grâce à Maskbook, le masque de protection respiratoire, symbole de pollution, se transforme en symbole de solutions. Maskbook rassemble des milliers de participants dans plus de 40 pays. ",
          "p2": "La Fondation Schneider Electric est le principal partenaire de Maskbook.  L’ONU Environnement et la Coalition pour le climat et l’air pur font partie de ses partenaires institutionnels depuis 2016."
        },
        "vid1": {
          "title": "L'art en action",
          "description": "Maskbook combat le changement climatique via la créativite"
        },
        "barometer1": {
          "title": "Résultats du baromètre Planète & Société 2015 &mdash; 2017",
          "cta": "Voir l’ensemble des résultats",
          "card1": {
            "title": "Développement",
            "stat": "148 145",
            "body": "personnes défavorisées formées à la gestion de l’énergie"
          },
          "card2": {
            "title": "Développement",
            "stat": "1 347",
            "body": "missions avec l’ONG Schneider Electric Teachers"
          }
        },
        "txt3": {
          "h2": "Faits marquants 2017 de la Fondation Schneider Electric",
          "title": "Investir 2 millions d’euros dans la formation de jeunes défavorisés",
          "p1": "Une véritable innovation doit être porteuse d’opportunités pour ceux qui en sont le plus dépourvus. C’est pourquoi nous nous attachons à utiliser l’innovation comme moyen d’ouvrir les horizons de la nouvelle génération, et notamment des jeunes défavorisés. À cet effet, la Fondation Schneider Electric a signé un partenariat avec le Conseil général de la congrégation des salésiens, pour un investissement de 2 millions d’euros. Cette initiative permettra dans un premier temps de financer cinq projets d’énergie renouvelable et de développement durable sélectionnés parmi une liste de propositions soumises par les divers établissements salésiens d’enseignement technique et professionnel à travers le monde. ",
          "p2": "L’objectif est d'aider les jeunes défavorisés en leur donnant des opportunités, tout en promouvant un mode de vie durable :",
          "li1": "À Goma, en République démocratique du Congo, le centre de formation professionnelle ITIG a pour projet de dispenser une formation théorique et pratique à des jeunes issus de familles pauvres.",
          "li2": "À Pinguli, près de Kudal, en Inde, les outils du laboratoire électrique du centre de formation local seront modernisés.",
          "li3": "À Haïti, une formation sera mise en place pour les enseignants, un nouveau laboratoire et des équipements scolaires seront achetés, et un nouveau système de génération d'électricité sera créé.",
          "li4": "À Maputo, au Mozambique, un programme de formation pour les étudiants et enseignants sera mis à jour dans le domaine de l'énergie.",
          "li5": "En Sicile, des cours d’innovation 4.0 portant sur l’électricité, l'électronique et les énergies renouvelables seront lancés."
        },
        "txt4": {
          "title": "Schneider Electric Teachers",
          "p1": "Par l’intermédiaire de l’ONG Schneider Electric Teachers, les collaborateurs peuvent se porter volontaires pour dispenser des formations. Ils font le lien entre l’entreprise, la Fondation et les organisations soutenues dans plus de 70 pays. Grâce à eux, 1 347 missions ont pu être menées à bien ces 3 dernières années."
        },
        "txtMedia2": {
          "title": "VolunteerIn",
          "p1": "Notre  plateforme multilingue VolunteerIn permet à tous les collaborateurs du Groupe de postuler à des missions de bénévolat au bénéfice des partenaires de la Fondation, comme par exemple des missions Schneider Electric Teachers. Les communautés liées à la Fondation (équipes, délégués, partenaires, ONGs) animent cette plateforme autour des thèmes de la formation professionnelle aux métiers de l’énergie, de l’accompagnement des familles en précarité énergétique, de la sensibilisation au développement durable et de l’entrepreneuriat."
        },
        "quoteVol": {
          "p": "Nous partageons la vision d’un monde nouveau, un monde dans lequel les personnes ont en main les clés de leur émancipation... Et les projets que nous développons avec Schneider Electric et Ashoka vont dans ce sens.",
          "title": "Directeur du développement durable,",
          "company": "Enel Distribution"
        },
        "quoteTeachers": {
          "p": "J'espère avoir donné autant que j'ai reçu pendant ma mission. Nous sommes une entreprise unique  grâce aux collaborateurs et aux initiatives telles que Schneider Electric Teachers. Je suis fier de travailler dans cette entreprise.",
          "title": "Commercial OEM,",
          "company": "Schneider Electric"
        },
        "snapshot1": {
          "title": "La Fondation Schneider Electric en quelques chiffres",
          "cell1": {
            "title": "€ 13,4 millions",
            "p1": "de dons en nature et en numéraire effectués par les collaborateurs et les entités Schneider Electric"
          },
          "cell2": {
            "title": "€ 4 millions",
            "p1": "de budget d'intervention de la Fondation"
          },
          "cell3": {
            "title": "130",
            "units": "délégués",
            "p1": "dans 80 pays"
          },
          "cell4": {
            "title": "1 347",
            "units": "Schneider Electric Teachers",
            "p1": "missions effectuées depuis 5 ans"
          },
          "cell5": {
            "title": "35 000",
            "p1": "collaborators"
          },
          "cell6": {
            "title": "35 000",
            "units": "contributeurs",
            "p1": "1 900 volontaires"
          },
          "cell7": {
            "title": "840",
            "units": "partenaires",
            "p1": "depuis la création de la Fondation"
          }
        },
        "txt5": {
          "title": "Innovation sociale pour lutter contre la précarité énergétique",
          "p1": "À la mi-juin 2017, la Fondation Schneider Electric, sous l’égide de la Fondation de France, et Ashoka ont lancé un nouvel appel à projets pour lutter contre la précarité énergétique, en partenariat avec Enel. Le but était de sélectionner les 15 organisations les plus innovantes, proposant des solutions créatives et porteuses de changement, pour lutter contre la précarité énergétique et promouvoir une énergie durable en Europe. Les gagnants ont été annoncés au cours de la 23e Conférence des Parties (COP 23) en novembre 2017."
        },
        "vid2": {
          "title": "Entrepreneuriat social",
          "description": "Les innovations gagnantes annonçées lors de la COP 23"
        },
        "txtMedia3": {
          "title": "Creative Klima à la COP 23 ",
          "p1": "Proposant des expositions, conférences, ateliers, débats, remise de Prix, programmation musicale et de nombreuses festivités, Creative Klima,une initiative de Art of Change 21,  a été une source d’inspiration pour s’engager à agir contre le changement climatique à l’occasion de la COP 23.",
          "p2": "Étaient partenaires de cet événement : la Fondation Schneider Electric, l’association Art of Change 21, l’ONG internationale Ashoka, l’Institut français Bonn, l’Atelier 21 et ses initiatives Paléo-Énergétique et Solar Sound System, et le Forum International Météo et Climat."
        },
        "references": {
          "referenceA": "<sup>1</sup> <a class='t-grey' href='https://www.iea.org/publications/freepublications/publication/weo-2017-special-report-energy-access-outlook.html' target='_blank'>Agence internationale de l’énergie, Energy Access Outlook 2017</a>"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/outreach/outreach-se-foundation-hero-lores.jpg')" :hiResSrc="require('@/assets/img/outreach/outreach-se-foundation-hero.jpg')" chapter="05" :section="$t('outreach.section')" :title="$t('outreach.title')" :grayBG="true" />

    <section class="l-bg-white l-section-pad">
      <TxtMedia>
        <p slot="main-content" v-html="$t('outreach.foundation.txtMedia1.p1')"></p>
        <img slot="sidebar" src="@/assets/img/outreach/Fuel-Poverty-Credits-Photos-Stephanie-Lacombe-1.jpg" alt="">
      </TxtMedia>
      <Table columns="2">
        <TableRow>
          <TableCell :bgimg="require('@/assets/img/outreach/A2E_India_4K5A7071.jpg')">
            <h3 id="sefoundationeducation" class="t-white" v-html="$t('outreach.foundation.table1.row1.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <p class="t-chartbody" v-html="$t('outreach.foundation.table1.row1.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 id="sefoundationenergygap" v-html="$t('outreach.foundation.table1.row2.cell1.title')"></h3>
          </TableCell>
          <TableCell bgc="#3dcd58">
            <p class="t-chartbody t-white" v-html="$t('outreach.foundation.table1.row2.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell :bgimg="require('@/assets/img/outreach/Kenti4.jpg')">
            <h3 id="sefoundationawareness" class="t-white" v-html="$t('outreach.foundation.table1.row3.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <p class="t-chartbody" v-html="$t('outreach.foundation.table1.row3.cell2.p1')"></p>
          </TableCell>
        </TableRow>
      </Table>
    </section>

    <section class="m-b-120 m-t-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('outreach.foundation.barometer1.title')"/>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('outreach.foundation.barometer1.cta')" target="_blank"/>
        <BarometerIndicator class="col-xs-18 col-sm-9" color="#42b4e6" :title="$t('outreach.foundation.barometer1.card1.title')" :stat="$t('outreach.foundation.barometer1.card1.stat')" :body="$t('outreach.foundation.barometer1.card1.body')"/>
        <BarometerIndicator class="col-xs-18 col-sm-9" color="#42b4e6" :title="$t('outreach.foundation.barometer1.card2.title')" :stat="$t('outreach.foundation.barometer1.card2.stat')" :body="$t('outreach.foundation.barometer1.card2.body')"/>
      </Barometer>
    </section>

    <hr />

    <section class="m-b-120 m-t-120">
      <Snapshot>
        <div slot="above">
          <h2 id="sefoundationnumbers" v-html="$t('outreach.foundation.snapshot1.title')" />
        </div>
        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('outreach.foundation.snapshot1.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('outreach.foundation.snapshot1.cell1.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" :double="true" :bgimg="require('@/assets/img/outreach/A2E_India_4K5A7046.jpg')">
          <h4 v-html="$t('outreach.foundation.snapshot1.cell2.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('outreach.foundation.snapshot1.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58" :double="true">
          <h4 v-html="$t('outreach.foundation.snapshot1.cell3.title')"></h4>
          <p class="t-chartbody" v-html="$t('outreach.foundation.snapshot1.cell3.units')"></p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('outreach.foundation.snapshot1.cell3.p1')"></p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('outreach.foundation.snapshot1.cell4.title')"></h4>
          <p class="t-chartbody t-green-light" v-html="$t('outreach.foundation.snapshot1.cell4.units')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('outreach.foundation.snapshot1.cell4.p1')"></p>
        </SnapshotCard>

        <!-- <SnapshotCard class="t-white" bgc="#626469">
          <h4 v-html="$t('outreach.foundation.snapshot1.cell5.title')"></h4>
          <p class="t-chartbody" v-html="$t('outreach.foundation.snapshot1.cell5.p1')"></p>
          <div class="t-hr t-hr--white"></div>
        </SnapshotCard> -->

        <SnapshotCard class="t-white" :double="true" :bgimg="require('@/assets/img/outreach/SE-TEACHERS_Credits-Adeline-Maleka.jpg')">
          <h4 v-html="$t('outreach.foundation.snapshot1.cell6.title')"></h4>
          <p v-html="$t('outreach.foundation.snapshot1.cell6.units')"></p>
          <div class="t-hr"></div>
          <p v-html="$t('outreach.foundation.snapshot1.cell6.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" :double="true" bgc="#3dcd58">
          <h4 v-html="$t('outreach.foundation.snapshot1.cell7.title')"></h4>
          <p class="t-chartbody" v-html="$t('outreach.foundation.snapshot1.cell7.units')"></p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('outreach.foundation.snapshot1.cell7.p1')"></p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <hr />

    <section class="m-b-120 m-t-120">
      <ImageFull class="m-b-50">
        <img src="@/assets/img/outreach/SEFoundation_training_8079.jpg" />
      </ImageFull>
    </section>

    <section class="m-t-120 m-b-120">
      <Txt class="m-b-120">
        <h2 id="sefoundationhighlights" v-html="$t('outreach.foundation.txt3.h2')"></h2>
        <h3 id="sefoundationinvesting" v-html="$t('outreach.foundation.txt3.title')"></h3>
        <p v-html="$t('outreach.foundation.txt3.p1')"></p>
        <p v-html="$t('outreach.foundation.txt3.p2')"></p>
        <ul>
          <li v-html="$t('outreach.foundation.txt3.li1')"></li>
          <li v-html="$t('outreach.foundation.txt3.li2')"></li>
          <li v-html="$t('outreach.foundation.txt3.li3')"></li>
          <li v-html="$t('outreach.foundation.txt3.li4')"></li>
          <li v-html="$t('outreach.foundation.txt3.li5')"></li>
        </ul>
      </Txt>

      <hr />

      <ImageFull class="m-t-120 m-b-50">
        <img src="@/assets/img/outreach/Fuel-Poverty_SSD_8311.jpg" />
      </ImageFull>
      <Txt class="">
        <h3 id="socialinnovation" v-html="$t('outreach.foundation.txt5.title')"></h3>
        <p v-html="$t('outreach.foundation.txt5.p1')"></p>
      </Txt>

    </section>

    <section class="m-b-120 m-t-120">
      <YouTubeVideo videoId="fb4GTsHI5tI" :title="$t('outreach.foundation.vid2.title')" :description="$t('outreach.foundation.vid2.description')" :preview="require('@/assets/img/thumbnails/Social-innovation-to-tackle-fuel-poverty.jpg')" />
    </section>

    <section class="m-b-120 m-t-120">
      <Quote :photo="require('@/assets/img/outreach/outreach-se-foundation-andrea-valcalda.jpg')" name="Andrea Valcalda" :title="$t('outreach.foundation.quoteVol.title')" :company="$t('outreach.foundation.quoteVol.company')">
        <div v-html="$t('outreach.foundation.quoteVol.p')"></div>
      </Quote>
    </section>

    <section class="m-b-120 m-t-120">
      <ImageFull class="m-b-50">
        <img src="@/assets/img/outreach/Maskbook_F2A4762.jpg" />
      </ImageFull>
      <Txt>
        <h3 id="maskbook" v-html="$t('outreach.foundation.txt2.title')"></h3>
        <p v-html="$t('outreach.foundation.txt2.p1')"></p>
        <p v-html="$t('outreach.foundation.txt2.p2')"></p>
      </Txt>
    </section>
    <section class="m-b-120 m-t-120">
      <YouTubeVideo videoId="B-nMK6fH1HU" :title="$t('outreach.foundation.vid1.title')" :description="$t('outreach.foundation.vid1.description')" :preview="require('@/assets/img/thumbnails/A-symbol-for-solutions_Maskbook.jpg')" />
    </section>

    <hr />

    <section class="m-b-120 m-t-120">
      <TxtMedia>
        <h3 id="creativeklima" slot="main-content" v-html="$t('outreach.foundation.txtMedia3.title')"></h3>
        <p slot="main-content" v-html="$t('outreach.foundation.txtMedia3.p1')"></p>
        <p slot="main-content" v-html="$t('outreach.foundation.txtMedia3.p2')"></p>

        <img slot="sidebar" src="@/assets/img/outreach/Creative-Klima_logo.jpg" alt="">
      </TxtMedia>
    </section>

    <!-- ************ -->

    <section class="m-t-120 l-bg-white l-section-pad">
      <Txt class="m-b-32">
        <!-- <h2 v-html="$t('outreach.foundation.txt1.h2')"></h2> -->
        <h3 id="disasterrelief" v-html="$t('outreach.foundation.txt1.title')"></h3>
        <p v-html="$t('outreach.foundation.txt1.p1')"></p>
        <p v-html="$t('outreach.foundation.txt1.p2')"></p>
      </Txt>
      <ImageFull class="m-b-80">
        <img src="@/assets/img/outreach/Hurricane-Maria-Dominica_Kalinago2.jpg" />
      </ImageFull>
    </section>

    <section class="m-b-120">
      <Quote class="m-b-80" :photo="require('@/assets/img/outreach/outreach-se-foundation-jose-pereira.jpg')" name="Jose Pereira" :title="$t('outreach.foundation.quoteTeachers.title')" :company="$t('outreach.foundation.quoteTeachers.company')">
        <div v-html="$t('outreach.foundation.quoteTeachers.p')"></div>
      </Quote>

      <TxtMedia>
        <h3 slot="main-content" v-html="$t('outreach.foundation.txt4.title')"></h3>
        <p id="seteachers" slot="main-content" v-html="$t('outreach.foundation.txt4.p1')"></p>
        <img slot="sidebar" src="@/assets/img/outreach/SETeachers_SSD.jpg" />
      </TxtMedia>
    </section>

    <hr />

    <section class="m-t-120 m-b-120">
      <ImageFull class="m-b-50">
        <img src="@/assets/img/outreach/VolunteerIn_20th_anniversary.jpg" alt="">
      </ImageFull>
      <Txt>
        <h3 id="volunteerin" v-html="$t('outreach.foundation.txtMedia2.title')"></h3>
        <p v-html="$t('outreach.foundation.txtMedia2.p1')"></p>
      </Txt>
    </section>

    <hr />

    <References class="m-b-30">
      <Reference>
        <div v-html="$t('outreach.foundation.references.referenceA')"></div>
      </Reference>
    </References>

   <div class="l-content">
      <FooterNav
        nextRoute="CompanyPerformance_Overview"
        prevRoute="Outreach_AccessToEnergy" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import ImageFull from '@/components/ImageFull'
import TxtMedia from '@/components/TxtMedia'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'

export default {
  name: 'Outreach_SchneiderElectricFoundation',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    ImageFull,
    TxtMedia,
    Table,
    TableRow,
    TableCell,
    Barometer,
    BarometerIndicator,
    Snapshot,
    SnapshotCard
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/outreach/schneider-electric-foundation.vue